module.exports = __webpack_public_path__ + "img/s03_p03.8df44fae.png";